import React, { Fragment } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon";
import { useTheme } from "@emotion/react";
import { WarningCircle } from "@phosphor-icons/react";

export const AccountBanned = () => {
  const theme = useTheme();

  return (
    <Fragment>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"} mb={2}>
        <GenericCircleIcon>
          <WarningCircle size={96} weight="thin" color={theme.palette.primary.main} />
        </GenericCircleIcon>
      </Box>
      <Stack gap={3} alignItems={"center"}>
        <Typography fontSize={"16px"} textAlign={"center"}>
          Your profile has been banned due to a violation of our community guidelines.
        </Typography>
        <Typography fontSize={"16px"} textAlign={"center"}>
          If you believe this ban was applied in error, or if you have any questions, please reach out to our support team.
        </Typography>
        <Stack direction={{ xs: "column", md: "row" }} gap={1} alignItems={"center"} justifyContent={"center"} width={"100%"}>
          <Button
            variant="contained"
            component="a"
            href="contact-us"
            target="_blank"
            sx={{ width: { xs: "100%", sm: "250px" }, color: "#FFF" }}
            rel="noopener noreferrer"
          >
            Contact us
          </Button>
        </Stack>
      </Stack>
    </Fragment>
  );
};
